<ng-container *ngIf="user">
  <app-toolbar [title]="title" [user]="user" [destination]="destination" [back]="back"></app-toolbar>
</ng-container>
<div class="container">
  <div style="vertical-align: middle; padding-bottom: 10px; text-align: center">
    <h2>Questionari</h2>
    <ng-container>
      <h4>Selezionare il questionario che avete intenzione di mandare al medico.</h4>
    </ng-container>
  </div>
  <mat-card class="mat-elevation-z10">
    <ng-container>
      <mat-selection-list class="mylist" [multiple]="false">
        <h4 *ngIf="questionnaires1.length!==0">Questionari che misurano l'attività della malattia:</h4>
        <mat-list-option class="mylist" *ngFor="let q of questionnaires1" [value]="q" (click)="goTo(q)">
        <mat-icon mat-list-icon>assignment</mat-icon>
          <span class="questionnaireDesc" *ngIf="mapReady"><p></p><b>{{q}}</b> {{descriptionQuestionnaireMap[q]}}</span>
          <span class="questionnaireDesc" *ngIf="!mapReady"><b>{{q}}</b> </span>
        </mat-list-option>

        <h4 *ngIf="questionnaires2.length!==0">Questionari che monitorano l'impatto della malattia su diversi ambiti della vita del paziente</h4>
        <mat-list-option class="mylist" *ngFor="let q of questionnaires2" [value]="q" (click)="goTo(q)">
          <mat-icon mat-list-icon>assignment</mat-icon>
          <span class="questionnaireDesc" *ngIf="mapReady"><b>{{q}}</b> {{descriptionQuestionnaireMap[q]}}</span>
          <span class="questionnaireDesc" *ngIf="!mapReady"><b>{{q}}</b> </span>
        </mat-list-option>

        <h4 *ngIf="questionnaires3.length!==0">Questionari che misurano la compatibilità con la terapia</h4>
        <mat-list-option class="mylist" *ngFor="let q of questionnaires3" [value]="q" (click)="goTo(q)">
          <mat-icon mat-list-icon>assignment</mat-icon>
          <span class="questionnaireDesc" *ngIf="mapReady"><b>{{q}}</b> {{descriptionQuestionnaireMap[q]}}</span>
          <span class="questionnaireDesc" *ngIf="!mapReady"><b>{{q}}</b> </span>
        </mat-list-option>
      </mat-selection-list>
    </ng-container>
  </mat-card>
</div>
